// extracted by mini-css-extract-plugin
export default {"information-wrapper":"Information_information-wrapper__KzmfV","response":"Information_response__85bl9"};